export class Joypad implements ISerializable
{
    private buttonStates: number = 0x00; // 8-bit status map of all physical buttons
    private shiftBuffer: number  = 0x00; // Active register shifting bits out to the CPU
    private strobe: boolean      = false;

    // Standard button bitmasks
    public static readonly BUTTON_A      = 1 << 0;
    public static readonly BUTTON_B      = 1 << 1;
    public static readonly BUTTON_SELECT = 1 << 2;
    public static readonly BUTTON_START  = 1 << 3;
    public static readonly BUTTON_UP     = 1 << 4;
    public static readonly BUTTON_DOWN   = 1 << 5;
    public static readonly BUTTON_LEFT   = 1 << 6;
    public static readonly BUTTON_RIGHT  = 1 << 7;

    /**
     * Controls the snapshot state of the controller keys.
     */
    public writeStrobe(value: number): void
    {
        this.strobe = (value & 0x01) !== 0;
        if (this.strobe) {
            // While strobe is high, the buffer continuously mirrors the real button states
            this.shiftBuffer = this.buttonStates;
        }
    }

    public peekState(): number
    {
        // TODO: Fix me. This probably doesn't make much sense.
        return this.buttonStates & 0x01;
    }

    /**
     * Pulls the status of the current topmost button out of the shift line.
     */
    public readState(): number
    {
        if (this.strobe) {
            return this.buttonStates & 0x01;
        }

        // Fetch the status bit of the current target button (Bit 0)
        const value = this.shiftBuffer & 0x01;

        // Shift our register right by 1 to prepare the next button for the next read call
        this.shiftBuffer >>= 1;

        // Standard NES hardware pull-up quirk: unused wires on the bus return 0x40.
        // Bit 0 holds the actual button information (0 = released, 1 = pressed).
        return value | 0x40;
    }

    /**
     * Modifies the internal button status tracker map.
     */
    public setButtonState(buttonMask: number, pressed: boolean): void
    {
        if (pressed) {
            this.buttonStates |= buttonMask;
        } else {
            this.buttonStates &= ~buttonMask;
        }
    }

    public serialize(): Record<string, any>
    {
        return {
            buttonStates: this.buttonStates,
            shiftBuffer:  this.shiftBuffer,
            strobe:       this.strobe,
        };
    }

    public deserialize(data: Record<string, any>): void
    {
        this.buttonStates = data.buttonStates;
        this.shiftBuffer  = data.shiftBuffer;
        this.strobe       = data.strobe;
    }
}
